export default {
  login: {
    title: "Akkauntingizga kiring",
    footer: "Akkauntni menejeringiz yaratadi va login bilan parolni beradi. Parolni unutdingizmi? Menejeringizga murojaat qiling.",
    username: "Login",
    usernamePlaceholder: "ism.familiya",
    password: "Parol",
    submit: "Kirish",
    failed: "Kirib bo'lmadi. Qayta urinib ko'ring.",
  },
  twofaSetup: {
    title: "Ikki bosqichli himoyani sozlang",
    subtitle: "Rolingiz uchun 2FA majburiy. Bir daqiqa: kodni autentifikator ilovasi bilan skanerlang.",
    continue: "Platformaga o'tish",
    signOut: "Chiqish",
    failed: "Sozlashni boshlab bo'lmadi.",
  },
  twofa: {
    title: "Ikki bosqichli tekshiruv",
    subtitle: "Authenticator ilovasidagi 6 xonali kodni kiriting.",
    subtitleBackup: "Zaxira kodlaringizdan birini kiriting.",
    verify: "Tekshirish",
    useAuthenticator: "Authenticator kodini ishlatish",
    useBackup: "Zaxira kodini ishlatish",
    backToSignIn: "Kirishga qaytish",
    lostPhone: "Telefoningiz yo'qoldimi? Zaxira kodini ishlating yoki egadan 2FA'ni tiklashni so'rang.",
    failed: "Tekshiruv muvaffaqiyatsiz.",
    digit: "{{n}}-raqam",
  },
  setPassword: {
    title: "O'z parolingizni qo'ying",
    subtitle: "Vaqtinchalik parol bilan kirdingiz. Davom etish uchun o'zingizning parolingizni tanlang.",
    newPassword: "Yangi parol",
    confirm: "Yangi parolni tasdiqlang",
    ruleLength: "Kamida 10 ta belgi",
    ruleMatch: "Parollar mos keladi",
    ruleDifferent: "Vaqtinchalik parol bilan bir xil emas",
    save: "Saqlash va davom etish",
    failed: "Parolni o'rnatib bo'lmadi.",
  },
};
